import { observable } from "mobx";
import Autobind from "autobind-decorator";

@Autobind
class SeriesListItemModel {
  @observable
  _uniqueID: string = "";
  @observable
  _thumbnailFrame: number = 0;

  constructor(uniqueID: string, thumbnailFrame: number = 0) {
    this._uniqueID = uniqueID;
    this._thumbnailFrame = 0;
  }

  get uniqueID() {
    return this._uniqueID;
  }
  set uniqueID(uniqueID: string) {
    this._uniqueID = uniqueID;
  }

  get thumbnailFrame() {
    return this._thumbnailFrame;
  }
  set thumbnailFrame(sliceNumber: number) {
    this._thumbnailFrame = sliceNumber;
  }
}

export default SeriesListItemModel;
